import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Temoignages = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [expandedCards, setExpandedCards] = useState({});

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const temoignages = [
    {
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      stars: 5,
      text: t('temoignages.client1.text'),
      author: t('temoignages.client1.name'),
      location: t('temoignages.client1.company')
    },
    {
      avatar: "https://randomuser.me/api/portraits/women/44.jpg", 
      stars: 5,
      text: t('temoignages.client2.text'),
      author: t('temoignages.client2.name'),
      location: t('temoignages.client2.company')
    },
    {
      avatar: "https://randomuser.me/api/portraits/men/65.jpg",
      stars: 5, 
      text: t('temoignages.client3.text'),
      author: t('temoignages.client3.name'),
      location: t('temoignages.client3.company')
    },
    {
      avatar: "https://randomuser.me/api/portraits/women/68.jpg",
      stars: 5,
      text: t('temoignages.client4.text'),
      author: t('temoignages.client4.name'),
      location: t('temoignages.client4.company')
    },
    {
      avatar: "https://randomuser.me/api/portraits/women/19.jpg",
      stars: 5,
      text: t('temoignages.client5.text'),
      author: t('temoignages.client5.name'),
      location: t('temoignages.client5.company')
    },
    {
      avatar: "https://randomuser.me/api/portraits/men/28.jpg",
      stars: 5,
      text: t('temoignages.client6.text'),
      author: t('temoignages.client6.name'),
      location: t('temoignages.client6.company')
    }
  ];

  const renderStars = (count) => {
    return "★".repeat(count);
  };

  const toggleExpanded = (index) => {
    setExpandedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const truncateText = (text, maxLines = 2) => {
    const words = text.split(' ');
    const maxWords = maxLines * 8; // Estimation: ~8 mots par ligne
    if (words.length <= maxWords) {
      return { text: text, isTruncated: false };
    }
    return { 
      text: words.slice(0, maxWords).join(' ') + '...', 
      isTruncated: true 
    };
  };

  return (
    <section className="temoignages section-animate" id="temoignages" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('temoignages.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('temoignages.subtitle')}
          </p>
        </div>
        
        <div className="temoignages-grid">
          {temoignages.map((temoignage, index) => {
            const { text: displayText, isTruncated } = truncateText(temoignage.text);
            const isExpanded = expandedCards[index];
            
            return (
              <div key={index} className="temoignage-card stagger-item card-premium focus-premium">
                <div className="temoignage-avatar">
                  <img src={temoignage.avatar} alt="Avatar client" />
                </div>
                <div className="temoignage-stars">
                  {renderStars(temoignage.stars)}
                </div>
                <div className="temoignage-text">
                  "{isExpanded ? temoignage.text : displayText}"
                </div>
                {isTruncated && !isExpanded && (
                  <button 
                    className="read-more-btn"
                    onClick={() => toggleExpanded(index)}
                  >
                    {t('temoignages.readMore')}
                  </button>
                )}
                {isTruncated && isExpanded && (
                  <button 
                    className="read-less-btn"
                    onClick={() => toggleExpanded(index)}
                  >
                    {t('temoignages.readLess')}
                  </button>
                )}
                <div className="temoignage-author">
                  - {temoignage.author}, {temoignage.location}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Temoignages; 